<template>
    <div id="modal" class="modal" v-if="display">
        <slot name="subModal"></slot>
        <div class="modal-content">
            <div v-if="isClose && closeType === 'CLOSE'" class="cancle" @click="modalClose">
                <img src="@/assets/img/icon/modal_close_gray.svg" alt="">
            </div>
            <div v-if="closeType === 'BACK'" class="back" @click="modalClose">
                <img src="@/assets/img/icon/modal_back.svg" alt="">
            </div>
            <div class="detail">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Modal',
    data () {
        return {
            openStatus: this.display,   
        }
    },
    props: {
        display: Boolean,
        closeType: {
            type: String,
            default: 'CLOSE'
        },
        isClose: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        display (val) {
            this.openStatus = val
        }
    },    
    methods: {
        modalClose: function (id) {
            // var elem = document.getElementById(id)
            // elem.style.display = 'none';
            this.$emit('modalStatus', false);
        },
    }
}
</script>
<style lang="scss">
    #modal{
        position: fixed; /* Stay in place */
        z-index: 999; /* Sit on top */
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgba(128, 128, 129,0.6); /* Black w/ opacity */
        .modal-content {
            position: relative;
            margin: auto;
            // padding: 30px 32px;
            border-radius: 20px;
            background-color: #ffffff;
            .back,
            .cancle{
                position: absolute;
                cursor: pointer;
                top: 16px;
                z-index: 5;
            }
            .cancle{
                right: 16px;
            }
            .back{
                left: 16px;
            }
            .detail{
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/Modal.vue